import request from '@/api/request'
import store from '@/store'

export function listMenu(query) {
  return request({
    url: '/system/menu/list',
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region,
    },
    params: query,
  })
}


